/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ filename: NonNullable<unknown> }} Uploadtoolarge2Inputs */

const en_uploadtoolarge2 = /** @type {(inputs: Uploadtoolarge2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.filename}" is too large (max 25 MB).`)
};

const pt_uploadtoolarge2 = /** @type {(inputs: Uploadtoolarge2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.filename}" é demasiado grande (máx. 25 MB).`)
};

/**
* | output |
* | --- |
* | "\"{filename}\" is too large (max 25 MB)." |
*
* @param {Uploadtoolarge2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const uploadtoolarge2 = /** @type {((inputs: Uploadtoolarge2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploadtoolarge2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_uploadtoolarge2(inputs)
	return pt_uploadtoolarge2(inputs)
});
export { uploadtoolarge2 as "uploadTooLarge" }